export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
    if (loading) state.error = null;
  },

  SET_CATALOG(state, catalog) {
    state.catalog = catalog || {};
    state.loaded = true;
    state.loading = false;
    state.error = null;
  },

  SET_ERROR(state, error) {
    state.error = error;
    state.loading = false;
  },
};
